import { render, staticRenderFns } from "./Christmas.vue?vue&type=template&id=ffe82e3a&scoped=true&"
import script from "./Christmas.vue?vue&type=script&lang=js&"
export * from "./Christmas.vue?vue&type=script&lang=js&"
import style0 from "./Christmas.vue?vue&type=style&index=0&id=ffe82e3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe82e3a",
  null
  
)

export default component.exports